import { useAppSelector } from './';
const useNavItems = () => {
  const navItems = useAppSelector(store => store.navItems);
  return navItems;
};
export default useNavItems;